import Layout from "./components/Layout";
import Main from "./components/Main";
import Title from "./components/Title";

function App() {
  return (
    <Layout>
      <Title />
      <Main />
    </Layout>
  );
}

export default App;
